var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-info is-fullheight",style:(_vm.layoutStyles)},[_c('Snow'),_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered box back-dark"},[_c('launcher')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }